// extracted by mini-css-extract-plugin
export default {"wrapper":"CommentHistoryFeed_wrapper__vXOv9","header":"CommentHistoryFeed_header__jn9y4"};